{
  "header": {
    "eyebrow": "Energy",
    "title": "ODA metering",
    "description": "Smart-meter connections read through the independent data service (ODA)."
  },
  "error": {
    "title": "Could not load metering points",
    "description": "The ODA service did not respond. Try again later."
  },
  "unavailable": {
    "title": "ODA is not available",
    "description": "The ODA metering module is not available in this environment."
  },
  "list": {
    "title": "Metering points",
    "count": "{{count}} metering point",
    "count_other": "{{count}} metering points",
    "searchPlaceholder": "Search EAN, meter or location…",
    "searchAria": "Search metering points",
    "filters": {
      "aria": "Metering point filters",
      "group": "Group",
      "groupChip": "{{name}} ({{count}})"
    },
    "columns": {
      "ean": "EAN",
      "location": "Location",
      "meter": "Meter",
      "lastData": "Last data",
      "messages": "Messages"
    },
    "empty": {
      "title": "No metering points",
      "description": "Nothing matches the current search or group filter."
    }
  },
  "detail": {
    "eyebrow": "ODA metering point",
    "noLocation": "No location name",
    "notFound": {
      "title": "Metering point not found",
      "description": "No ODA data for {{id}}.",
      "back": "Back to overview"
    },
    "info": {
      "title": "Connection details",
      "connection": "Connection",
      "meterId": "Meter",
      "location": "Location",
      "externalReference": "Reference",
      "activity": "Activity",
      "firstSeen": "First seen",
      "lastSeen": "Last seen",
      "totalMessages": "Total messages",
      "capacity": "Capacity",
      "fuseType": "Fuse type",
      "fuseLimit": "Estimated limit",
      "safetyMargin": "Safety margin"
    },
    "metered": {
      "title": "Metered data",
      "daysTitle": "Daily energy",
      "chartTitle": "15-minute intervals",
      "chartAria": "Energy per 15-minute interval for the selected days",
      "registerAria": "Register filter",
      "register": {
        "both": "Both",
        "consumption": "Consumption",
        "production": "Production"
      },
      "consumption": "consumption",
      "production": "production",
      "fuseCapacity": "Fuse capacity",
      "plotAria": "Plot {{date}}",
      "columns": {
        "date": "Date",
        "consumption": "Consumption",
        "production": "Production"
      },
      "noDays": {
        "title": "No daily energy",
        "description": "This metering point has no daily energy data yet."
      },
      "noSelection": {
        "title": "No day selected",
        "description": "Tick a day in the list to plot its interval readings."
      },
      "loadFailed_one": "{{count}} selected day couldn’t be loaded.",
      "loadFailed_other": "{{count}} selected days couldn’t be loaded."
    }
  }
}
